<form
  (ngSubmit)="handleSubmitClick()"
  [formGroup]="form">
  <div class="flex h-full items-stretch gap-6">
    <div class="w-100">
      <app-form-control
        [withBottomMargin]="false"
        label="Logotyp">
        <app-multimedia-choose-or-upload-control
          [formControl]="form.controls.logo" />
      </app-form-control>

      <app-form-control
        [withBottomMargin]="false"
        label="Zdjęcie główne">
        <app-multimedia-choose-or-upload-control
          [formControl]="form.controls.illustration" />
      </app-form-control>
    </div>

    <div class="flex flex-1 flex-col bg-gray-50 p-6">
      <div>
        <app-form-control label="Nazwa">
          <input
            [formControl]="form.controls.name"
            appPrimengInputText
            pInputText
            placeholder="Wprowadź nazwę" />
        </app-form-control>

        @if (isEditContext()) {
          <app-form-control label="Slug">
            <input
              [formControl]="form.controls.slug"
              appPrimengInputText
              pInputText
              placeholder="Wprowadź slug" />
          </app-form-control>
        }

        <app-form-control
          hint="Przykład: https://domain.com"
          label="Strona domowa">
          <input
            [formControl]="form.controls.homeUrl"
            appPrimengInputText
            pInputText
            placeholder="Wprowadź stronę domową" />
        </app-form-control>

        <app-form-control label="Status">
          <p-select
            [formControl]="form.controls.status"
            [options]="valueOrDefault(statusSelectItems$ | async, [])"
            appPrimengSelect
            [fluid]="true"
            placeholder="Wybierz status" />
        </app-form-control>

        <app-form-control label="Opis">
          <app-summernote
            [formControl]="form.controls.description"
            [uploadFn]="uploadFn()" />
        </app-form-control>

        <app-form-control label="Media społecznościowe">
          <app-admin-brand-social-media [formControl]="form.controls.socials" />
        </app-form-control>
      </div>

      <div class="mt-auto flex justify-end">
        <p-button
          [disabled]="form.invalid"
          appPrimengButton
          label="Zapisz"
          severity="primary"
          type="submit" />
      </div>
    </div>
  </div>
</form>
